import type { EntityType, IicState } from './types';

export function buildCreatePayload(
  type: EntityType,
  name: string,
  state: IicState,
): Record<string, unknown> {
  const enterprise = state.enterprises[0];
  const project = state.investmentProjects[0];
  const target = state.leads[0] || project;
  switch (type) {
    case 'leads':
      return {
        name,
        status: '新线索',
        priority: '中',
        type: '其他合作线索',
        sourceType: '手工录入',
        nextAction: '完成首次沟通并确认招商需求',
      };
    case 'enterprises':
      return {
        name,
        shortName: name.slice(0, 12),
        relationshipStatus: '目标企业',
        description: '待补充企业档案。',
      };
    case 'contacts':
      if (!enterprise) throw new Error('请先创建企业');
      return {
        name,
        enterpriseId: enterprise.id,
        role: '项目联系人',
      };
    case 'investmentProjects':
      if (!enterprise) throw new Error('请先创建企业');
      return {
        name,
        enterpriseId: enterprise.id,
        status: 'ACTIVE',
        stage: '初步接洽',
        priority: '中',
        nextAction: '确认项目投资与落地需求',
      };
    case 'landingProjects':
      throw new Error('请从已签约招商项目执行转落地');
    case 'enterpriseServices':
      if (!enterprise) throw new Error('请先创建企业');
      return {
        name,
        enterpriseId: enterprise.id,
        type: '综合服务',
        status: '新需求',
        urgency: '中',
        problem: '待补充企业问题。',
        target: '形成可执行的服务方案。',
      };
    case 'tasks':
      if (!target) throw new Error('请先创建线索或招商项目');
      return {
        name,
        targetType: state.leads[0] ? 'LEAD' : 'INVESTMENT_PROJECT',
        targetId: target.id,
        dueDate: new Date().toISOString().slice(0, 10),
        priority: '中',
        status: '待处理',
      };
    case 'carriers':
    case 'policyFunds':
    case 'cooperationResources':
      return {
        name,
        category:
          type === 'carriers'
            ? '载体空间'
            : type === 'policyFunds'
              ? '政策资金'
              : '合作资源',
        contactStatus: '未联系',
        description: '待补充资源详细信息。',
      };
    case 'activities':
      return { name, status: 'UPCOMING' };
    default:
      return { name };
  }
}
